module.exports = __webpack_public_path__ + "img/Pista-com-faixa-seccionada.88be0f01.png";